<template>
  <v-layout row wrap>
    <v-flex xs12 lg6>
      <input-form @close="close" @save="save" @deleteFile="deleteFile" @download="download" @upload="trigerupload" :title="title" :editable="editable" :approval="approval"
                  :printable="printable" @print="print" :cancelable="cancelable" @cancel="cancel" :attachable="true" :havefile="true"
                  :deletable="deletable" @delete="_delete">
        <input ref="fileUpload" type="file" name="upload" id="upload" accept="application/pdf" hidden @change="onChangeFile"/>
        <v-container grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12 lg4>
              <v-text-field label="Batch No." v-model="realization.batchNo" readonly disabled />
            </v-flex>
            <v-flex xs12 lg4>
              <v-layout row wrap class="ma-0">
              <v-select :items="docStates" v-model="realization.documentState" label="Document State"
                        v-if="docStatesLoaded && typeof (docStates.find(x => x === realization.documentState)) !== 'undefined'"
                        return-object :disabled="docStatebackup?false:!editable || submitted" :readonly="docStatebackup?false:!editable || submitted" required
                        @input="change" />
              <v-text-field :value="realization.documentState" label="Document State"
                            readonly disabled @input="change" v-else />
              <v-icon v-if="docStatebackup || (submitted || editable && docStatesLoaded && typeof (docStates.find(x => x === realization.documentState)) === 'undefined')" :color="docStatebackup?'error':'success'" class="mx-3 pointer" @click="editDocState">{{docStatebackup?'cancel':'edit'}}</v-icon>
              </v-layout>
            </v-flex>
            <v-icon v-if="isTempLockedAllowed && (submitted || editable)" color="error" class="mx-2 pointer" @click="tempLock">locked</v-icon>
            <v-flex xs12 lg4>
              <v-text-field :value="realization.sppdState" label="SPPD State" readonly disabled @input="change" />
            </v-flex>
            <v-flex xs12 lg4>
              <date-time-picker label="Realization Date" v-model="realization.realizationDate" @input="change"
                                :disabled="!editable" :readonly="!editable" date-only required />
            </v-flex>
            <v-flex xs12 lg4>
              <v-text-field label="HC Organization" v-model="realization.hcOrganization.name" disabled readonly />
            </v-flex>
            <v-flex xs12 lg4>
              <v-text-field label="Employee Nik" v-model="realization.sppdEmployee.employee.nik"
                            disabled readonly />
            </v-flex>
            <v-flex xs12 lg6>
              <v-layout row wrap class="ma-0">
              <v-text-field label="Business Trip Request Batch No." v-model="realization.sppdEmployee.sppd.batchNo"
                            readonly disabled />
              <v-icon color="primary" class="mx-3 pointer" @click="routeTo(realization.sppdEmployee.sppd.id)">open_in_browser</v-icon>
              </v-layout>
            </v-flex>
            <v-flex xs12 lg6>
              <v-text-field label="Employee Name" v-model="realization.sppdEmployee.employee.name" readonly disabled />
            </v-flex>
            <v-flex xs12 lg4>
              <v-text-field v-model="realization.sppdEmployee.employee.job.jobClass" label="Employee Job Class" disabled readonly />
            </v-flex>
            <v-flex xs12 lg4>
              <v-text-field v-model="realization.sppdEmployee.employee.job.jobProfileName" label="Employee Job Profile" disabled readonly />
            </v-flex>
            <v-flex xs12 lg4>
              <v-text-field v-model="realization.sppdEmployee.employee.job.divisionDept" label="Employee Division/Department" disabled readonly />
            </v-flex>
            <v-flex xs12 lg4>
              <v-text-field label="Imposition Type" v-model="realization.sppdEmployee.sppd.impositionType"
                            readonly disabled />
            </v-flex>
            <v-flex xs12 lg4>
              <v-text-field label="Imposition" v-model="realization.sppdEmployee.sppd.imposition.impositionName"
                            readonly disabled />
            </v-flex>
            <v-flex xs12 lg4>
              <v-text-field label="Imposition Organization"
                            v-model="realization.sppdEmployee.sppd.imposition.organization.name"
                            readonly disabled />
            </v-flex>
            <v-flex xs12 lg6>
              <v-text-field label="From City" v-model="realization.sppdEmployee.fromCity.value"
                            required readonly disabled />
            </v-flex>
            <v-flex xs6 lg3>
              <v-text-field label="From Lat" v-model="realization.fromLat" @input="change"
                            :disabled="!editable" :readonly="!editable" />
            </v-flex>
            <v-flex xs6 lg3>
              <v-text-field label="From Long" v-model="realization.fromLong" @input="change"
                            :disabled="!editable" :readonly="!editable" />
            </v-flex>
            <v-flex xs12 lg6>
              <v-text-field label="To City" v-model="realization.sppdEmployee.toCity.value"
                            required readonly disabled />
            </v-flex>
            <v-flex xs6 lg3>
              <v-text-field label="To Lat" v-model="realization.toLat" @input="change"
                            :disabled="!editable" :readonly="!editable" />
            </v-flex>
            <v-flex xs6 lg3>
              <v-text-field label="To Long" v-model="realization.toLong" @input="change"
                            :disabled="!editable" :readonly="!editable" />
            </v-flex>
            <v-flex xs12 lg6>
              <date-time-picker label="From Date" v-model="realization.fromDate" @input="change"
                                :disabled="!editable" :readonly="!editable" :rules="rules.fromDate" />
            </v-flex>
            <v-flex xs12 lg6>
              <date-time-picker label="To Date" v-model="realization.toDate" @input="change"
                                :disabled="!editable" :readonly="!editable" :rules="rules.toDate" />
            </v-flex>
            <v-flex xs12 lg4>
              <number-text-field label="Total Received"
                            :value="realization.sppdEmployee.receivedFundTotal"
                            :append-icon="realization.sppdEmployee.receivedFundNote !== null ? 'note' : ''"
                            :append-icon-cb="showReceivedFundNote"
                            readonly prefix="Rp." />
            </v-flex>
            <v-flex xs12 lg4>
              <number-text-field label="Total Realization" :value="totalRealization" readonly disabled prefix="Rp." />
            </v-flex>
            <v-flex xs12 lg4>
              <number-text-field label="Difference" :value="difference" readonly disabled prefix="Rp." />
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Purpose" v-model="realization.sppdEmployee.purpose" readonly disabled />
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Remark" v-model="realization.sppdEmployee.remark" multi-line rows="2"
                            readonly disabled />
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Realization Note" v-model="realization.realizationNote" multi-line rows="3"
                            :rules="rules.realizationNote" @input="change" :disabled="!editable"
                            :readonly="!editable" />
            </v-flex>
          </v-layout>
        </v-container>
      </input-form>
    </v-flex>
    <v-flex xs12 lg6>
      <router-view :value="realization" :newExpenseRoute="newExpenseRoute" :expenseDetailRoute="expenseDetailRoute"
                   :editable="editable" showGenerateExpense @generateExpense="generateExpense"
                   @updateExpense="updateExpense"/>
    </v-flex>
  </v-layout>
</template>

<script>
import Vuex from 'vuex'
import InputForm from '@/components/InputForm'
import DateTimePicker from '@/components/lookup/DateTimePicker'
import NumberTextField from '@/components/lookup/NumberTextField'

const genericStore = Vuex.createNamespacedHelpers('Generic')
const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')

export default {
  name: 'BtRealizationForm',
  components: {
    InputForm,
    DateTimePicker,
    NumberTextField
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: 'Business Trip Realization Form'
    },
    expenseDetailRoute: {
      type: [String, Object],
      required: true
    },
    newExpenseRoute: {
      type: [String, Object],
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
    approval: {
      type: Boolean,
      required: false,
      default: true
    },
    printable: {
      type: Boolean,
      required: false,
      default: false
    },
    cancelable: {
      type: Boolean,
      required: false,
      default: false
    },
    deletable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      isTempLockedAllowed: false,
      realization: this.value,
      docStatesLoaded: false,
      docStatebackup: null,
      realizationStatebackup: null,
      submitted: this.value.documentState === 'SUBMITTED',
      rules: {
        hcOrganization: [
          v => v.id !== '' || 'Organization is required'
        ],
        sppdEmployee: [
          v => v.id !== '' || 'Employee Business Trip Request is required'
        ],
        realizationNote: [
          v => v.length <= 500 || 'Max. 500 characters'
        ],
        fromDate: [
          v => (this.realization.fromDate <= this.realization.toDate) || 'Invalid to date.'
        ],
        toDate: [
          v => (this.realization.fromDate <= this.realization.toDate) || 'Invalid to date.'
        ]
      }
    }
  },
  computed: {
    ...genericStore.mapState({
      docStates: 'docStates'
    }),
    totalRealization () {
      return this.realization.expenses.filter(x => x._tag.status !== 'delete').map(x => parseInt(x.subTotal)).reduce((x, y) => x + y, 0)
    },
    difference () {
      return parseInt(this.realization.sppdEmployee.receivedFundTotal) - parseInt(this.totalRealization)
    }
  },
  methods: {
    ...genericStore.mapActions({
      listDocStates: 'listDocStates'
    }),
    ...dialogsStore.mapActions({
      showConfirmation: 'showConfirmation',
      closeConfirmation: 'closeConfirmation'
    }),
    routeTo (id) {
      this.$router.push({name: 'business-trip-request-detail',
        params: {
          id: id,
          backRoute: {
            name: 'business-trip-request-list'
          }
        }})
    },
    editDocState () {
      if (this.docStatebackup) {
        this.cancelDocState()
      } else {
        this.docStatebackup = this.realization.documentState
        this.realizationStatebackup = this.realization.sppdState
        this.realization.documentState = 'DRAFTED'
        this.realization.sppdState = 'REALIZATION'
      }
    },
    onChangeFile (e) {
      const self = this
      const file = e.target.files[0]
      this.$store.dispatch('Action/setLoading', true)
      if (file.size <= 5000000) {
        this.$backend.upload.singleFileUploadUsingPOST({file: e.target.files[0], batchno: this.realization.batchNo}).then(() => {
          this.$store.dispatch('Action/setLoading', false)
          self.showConfirmation({
            message: 'File uploaded',
            title: 'Upload success',
            buttons: [{label: 'Ok', handler: () => self.closeConfirmation()}]
          })
        }).catch((e) => {
          this.$store.dispatch('Action/setLoading', false)
          self.showConfirmation({
            message: e.message,
            title: 'Upload failed',
            buttons: [{label: 'Ok', handler: () => self.closeConfirmation()}]
          })
        })
      } else {
        this.$store.dispatch('Action/setLoading', false)
        self.showConfirmation({
          message: 'File size exceeded',
          title: 'Upload failed',
          buttons: [{label: 'Ok', handler: () => self.closeConfirmation()}]
        })
      }
    },
    trigerupload () {
      var event = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true
      })
      var cb = document.getElementById('upload')
      cb.dispatchEvent(event)
    },
    download () {
      const self = this
      this.$store.dispatch('Action/setLoading', true)
      this.$backend.upload.downloadUsingGET({id: this.realization.batchNo}).then((res) => {
        this.$store.dispatch('Action/setLoading', false)
        window.open(URL.createObjectURL(res.data))
      }).catch((e) => {
        this.$store.dispatch('Action/setLoading', false)
        self.showConfirmation({
          message: e.response.data,
          title: 'Download failed',
          buttons: [{label: 'Ok', handler: () => self.closeConfirmation()}]
        })
      })
    },
    deleteFile () {
      const self = this
      self.showConfirmation({
        title: 'Delete Business Trip Realization File. This process cannot be undone.',
        message: 'Are you sure?',
        buttons: [
          {
            label: 'Yes',
            handler: () => {
              this.$store.dispatch('Action/setLoading', true)
              this.$backend.upload.deleteUsingDELETE({id: this.realization.batchNo})
                .then(async (res) => {
                  self.closeConfirmation()
                  this.$store.dispatch('Action/setLoading', false)
                  self.showConfirmation({
                    message: 'Delete success',
                    title: 'Delete failed',
                    buttons: [{label: 'Ok', handler: () => self.closeConfirmation()}]
                  })
                }).catch(async (e) => {
                  self.closeConfirmation()
                  this.$store.dispatch('Action/setLoading', false)
                  self.showConfirmation({
                    message: e.response.data,
                    title: 'Delete failed',
                    buttons: [{label: 'Ok', handler: () => self.closeConfirmation()}]
                  })
                })
            }
          },
          {label: 'No', handler: () => self.closeConfirmation()}
        ]
      })
    },
    cancelDocState () {
      this.realization.documentState = this.docStatebackup
      this.realization.sppdState = this.realizationStatebackup
      this.realizationStatebackup = null
      this.docStatebackup = null
    },
    close () {
      this.$emit('close')
    },
    save () {
      this.realization.totalRealization = this.totalRealization
      this.$emit('save', this.realization)
    },
    change () {
      this.$emit('input', this.realization)
    },
    tempLock () {
      this.$emit('tempLock', this.realization)
    },
    loadResources () {
      const self = this
      self.listDocStates({vueinstance: self})
        .then(res => {
          self.docStatesLoaded = true
        })

      var authorities = self.$store.getters.authorities
      for (var index in authorities) {
        console.log(authorities[index].authority)
        if (authorities[index].authority === 'ROLE_HCADMIN') {
          self.isTempLockedAllowed = true
        }
      }
    },
    generateExpense () {
      this.$emit('generateExpense')
    },
    updateExpense (expenses) {
      this.$emit('updateExpense', expenses)
    },
    print () {
      this.$emit('print', this.realization)
    },
    cancel () {
      this.$emit('cancel', this.realization)
    },
    _delete () {
      this.$emit('delete', this.realization)
    },

    showReceivedFundNote () {
      const self = this

      self.showConfirmation({
        title: 'Received Fund Note',
        message: self.realization.sppdEmployee.receivedFundNote,
        buttons: [
          {label: 'Close', handler: self.closeConfirmation}
        ]
      })
    }
  },
  mounted () {
    this.loadResources()
  }
}
</script>

<style scoped>
.pointer{
  cursor: pointer;
}
#upload{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/bt-realization/BtRealizationForm.vue